import { PrimeIcons } from 'primeng/api';

export const DesignTokenLevelIcons = {
  PRIMITIVE: PrimeIcons.HASHTAG,
  SEMANTIC: PrimeIcons.LINK,
  COMPONENT: PrimeIcons.BOX,
};
